import React from 'react'

const EnhanceMarketing = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <g fillRule="evenodd" clipRule="evenodd">
                        <path
                            fill="#60a9eb"
                            d="m97.6 148.9 102.3-27.4c8.7-2.3 17.8 2.9 20.1 11.6 9.3 34.7 27 100.7 36.3 135.4 2.3 8.7-2.9 17.8-11.6 20.1L142.4 316c-19.1 5.1-38.8-6.3-43.9-25.4l-26.2-97.8c-5.2-19 6.2-38.7 25.3-43.9z"
                            opacity={1}
                            data-original="#b45a35"
                            className="hovered-path"
                        />
                        <path
                            fill="#60a9eb"
                            d="m97.6 148.9 102.3-27.4c8.7-2.3 17.8 2.9 20.1 11.6l24.7 92.3-85 22.8c-19.1 5.1-38.9-6.3-44-25.4L96 149.3c.5-.1 1.1-.2 1.6-.4z"
                            opacity="0.7019607843137254"
                            data-original="#dd6e42"
                            className=""
                        />
                        <path
                            fill="#1975c9"
                            d="M220.9 136.5 342.2 22.7l37.6 140.2 37.5 140.2-161.9-37.9-17.2-64.4z"
                            opacity="0.788235294117647"
                            data-original="#fdb614"
                            className=""
                        />
                        <path
                            fill="#1975c9"
                            d="m400.3 239.4 17 63.7-161.9-37.9-10.7-39.7z"
                            opacity={1}
                            data-original="#cd962b"
                            className=""
                        />
                        <path
                            fill="#60a9eb"
                            d="M395.4 102c22.2 4.1 41.2 20.6 47.5 43.9 6.2 23.3-2 47.1-19.2 61.8z"
                            opacity={1}
                            data-original="#b45a35"
                            className="hovered-path"
                        />
                        <path
                            fill="#60a9eb"
                            d="M218.9 295.5c-28.1 61.7 46.3 107.1-7.8 121.5-13.4 3.5-28.3 9.9-30.7-7.1l-13.7-100.4z"
                            opacity="0.7019607843137254"
                            data-original="#dd6e42"
                            className=""
                        />
                    </g>
                    <path
                        fill="#ffc200"
                        d="M473.9 143.8c-3.3.9-6.6-1.1-7.5-4.3-.9-3.3 1-6.6 4.3-7.5l23.2-6.2c3.3-.9 6.6 1.1 7.5 4.3.9 3.3-1.1 6.6-4.3 7.5zm-31.2-54.9c-2.2 2.6-6 2.9-8.6.7s-2.9-6-.7-8.6l19.4-23c2.2-2.6 6-2.9 8.6-.7s2.9 6 .7 8.6zM466.9 206c-3.2-1.2-4.8-4.6-3.7-7.8s4.6-4.8 7.8-3.7l23.7 8.5c3.1 1.1 4.8 4.6 3.7 7.8s-4.6 4.8-7.8 3.7z"
                        opacity={1}
                        data-original="#fcb13b"
                        className=""
                    />
                    <path
                        fill="#60a9eb"
                        fillRule="evenodd"
                        d="M352.5 1.5c-8.2 2.2-13.1 10.7-10.9 18.9l76.3 285c2.2 8.2 10.7 13.1 18.9 10.9 8.2-2.2 13.1-10.7 10.9-18.9l-76.3-285c-2.2-8.1-10.7-13.1-18.9-10.9z"
                        clipRule="evenodd"
                        opacity="0.7019607843137254"
                        data-original="#dd6e42"
                        className=""
                    />
                    <path
                        fill="#60a9eb"
                        fillRule="evenodd"
                        d="m236.2 290.9 8.6 53.3-28.3 7.6-.1-.2c-4.9-16.5-7.1-35.3 2.4-56z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#b45a35"
                        className="hovered-path"
                    />
                    <path
                        fill="#fad1a2"
                        fillRule="evenodd"
                        d="M145.9 470.4c73.4-15.2 53.5 1.6 121.4-33.1 26-13.3 16.6-35.4-2.7-31.4 39.2-17.9 18.4-41.8-9-29.5 37.8-13.4 30.4-50.5-9.8-30 34.8-15.6 23.9-48.1-12.9-31.5-31 14-37.9 36.3-65.8 9.4-34.4 16.4-27.1 33.5-61.3 56.8z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#fad1a2"
                        className=""
                    />
                    <path
                        fill="#3a4f59"
                        fillRule="evenodd"
                        d="m49.4 511-39-87.1 95.4-42.8 40.1 89.3z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#3a4f59"
                        className=""
                    />
                    <path
                        fill="#506e7a"
                        fillRule="evenodd"
                        d="M113.8 495.9 65.7 388.6l35.5-17.9 49.3 110z"
                        clipRule="evenodd"
                        opacity={1}
                        data-original="#506e7a"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default EnhanceMarketing